import slugify from 'slugify';

function removeDiacritics(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export const decodeUriComponentSafely = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const getSlug = (name: string): string => {
  const diacriticsRemovedValue = removeDiacritics(name);
  return slugify(diacriticsRemovedValue, {
    strict: true,
    replacement: '-',
  }).toLowerCase();
};

export const getUrlSlug = (value: string): string =>
  getSlug(decodeUriComponentSafely(value));
